import React, { Component } from "react";

//// componentes reutilizables
import Titulo from "../../generico/TituloPagina";
import Select from "react-select";
import { trackPromise } from 'react-promise-tracker';
import Popup from "react-popup";
import EmpresasConvenioService from "../../../services/convenios/EmpresasConvenioService.js";
import CardEmpresa from "../convenios/CardEmpresa";
import history from "../login/history";
import { conveniosImg } from "../../generico/utils/UrlAPI";
import ConfigService from "../../../services/configuracion/ConfigService";


const selectTodos = { value: undefined, label: "TODOS" };
const FILTER_STATE = {
  RUBROS: "rubros",
  CIUDADES: "ciudades",
  TEXTO: "texto"
}


export default class EmpresasConvenio extends Component {

  constructor(props) {
    super(props);

    this.state = {
      rubros: [selectTodos],
      rubrosFiltrado: [],
      ciudades: [selectTodos],
      empresas: [],
      empresasFiltrado: [],
      filtrosActivos: [{ state: "rubros", value: undefined }, { state: "ciudades", value: undefined }],
      filtroTexto: ""
    };

    this.selectorValue = this.selectorValue.bind(this);

  }

  componentDidMount() {
    this.getEmpresasDisponibles();
  }

  getEmpresasDisponibles() {
    trackPromise(
      EmpresasConvenioService.getEmpresasConvenio()
        .then(async (response) => {

          if (response.data.codigoRetorno === 0) {
            let empresas = response.data.datos;


            let { rubros, ciudades } = this.state;

            let arrayBase64 = [];
            let logoBase64, flyerBase64 = null;

            for (let empresa of empresas) {

              try {

                logoBase64 = empresa.logoEmpresa && await this.getBase64FromUrl(conveniosImg + empresa.logoEmpresa);
                flyerBase64 = empresa.imagenFlyer && await this.getBase64FromUrl(conveniosImg + empresa.imagenFlyer);


                arrayBase64.push({
                  idEmpresa: empresa.idEmpresa,
                  logoBase64,
                  flyerBase64
                });

              } catch (error) {
                console.log({ empresa, error })
              }

              //si no existe guardar
              if (!rubros.some(rubro => rubro?.value === empresa.rubroEmpresa.idRubro)) {
                rubros.push({
                  value: empresa.rubroEmpresa.idRubro,
                  label: empresa.rubroEmpresa.descripcion
                });
              }

              if (empresa.ciudadesConvenio !== null) {

                empresa.ciudadesConvenio.forEach((ciudadConvenio) => {

                  //si no existe guardar
                  if (!ciudades.some(ciudad => ciudad?.value === ciudadConvenio.idCiudad)) {
                    ciudades.push({
                      value: ciudadConvenio.idCiudad,
                      label: ciudadConvenio.descripcion
                    });
                  }

                })

              }

            };

            //guardar las imagenes en base64 en session storage
            sessionStorage.setItem("imgEmpresas", JSON.stringify(arrayBase64));

            this.setState({
              rubros,
              ciudades,
              empresas,
              empresasFiltrado: empresas
            });

          } else {
            Popup.queue(this.notifiPopup("Error", response.data.mensajeRetorno));
            return;
          }
        })
        .catch((error) => {
          console.log(error);
          Popup.queue(this.notifiPopup(
            "Info",
            "Error Inesperado. Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste."
          ));
          return;
        })

    )
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  comparaObjetos(arreglo, valor) {
    for (var i = 0; i < arreglo.length; i++) {
      if (arreglo[i].codEntidad === valor.codEntidad) {
        return true;
      }
    }
    return false;
  }

  compare(a, b) {

    const bandA = a.desEntidad.toUpperCase();
    const bandB = b.desEntidad.toUpperCase();

    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }
    return comparison;
  }

  async getBase64FromUrl(url) {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data);
      }
    });
  }

  /**
   * Filtrar el listado de empresas
   * @param {Object} state - valor utilizado en el Select
   * @param {Object} selectValue - valor seleccionado en el Select
   * @param {Object} texto - valor obtenido en el input del buscador
   */
  handleChangeFilter = ({ state, selectValue, texto }) => {

    let { empresas, empresasFiltrado, filtrosActivos, filtroTexto } = this.state;

    filtroTexto = texto !== undefined ? texto.trim() : filtroTexto;
    empresasFiltrado = empresas;

    if (state && selectValue) {
      //actualizar filtros activos
      filtrosActivos = filtrosActivos.map(filtro => {
        return filtro.state === state
          ? {
            ...filtro,
            value: selectValue.value
          }
          : filtro
      });
    }

    //si hay algun filtro activo, filtrar primero
    let filtrosValidos = filtrosActivos.filter(filtro => filtro.value);

    if (filtrosValidos.length > 0) {

      //si es solo un filtro, aplicar a la fuente principal
      if (filtrosValidos.length === 1) {

        let filtro = filtrosValidos[0];

        empresasFiltrado = empresas.filter(empresa =>
          filtro.state === FILTER_STATE.RUBROS
            ? empresa.rubroEmpresa.idRubro === filtro.value
            : empresa.ciudadesConvenio.some(ciudadConvenio => ciudadConvenio.idCiudad === filtro.value)
        )

      } else {

        //si son varios filtros, aplicar varias veces al resultado del filtro
        filtrosValidos.forEach(filtro => {
          empresasFiltrado = empresasFiltrado.filter(empresa =>
            filtro.state === FILTER_STATE.RUBROS
              ? empresa.rubroEmpresa.idRubro === filtro.value
              : empresa.ciudadesConvenio.some(ciudadConvenio => ciudadConvenio.idCiudad === filtro.value)
            //: empresa.ciudadEmpresa.idCiudad === filtro.value
          );
        });

      }

    } else {
      empresasFiltrado = empresas;
    }

    //por ultimo filtrar con el texto
    if (filtroTexto.length > 0) {
      empresasFiltrado = empresasFiltrado.filter(empresa =>
        empresa.nombreEmpresa.toUpperCase().indexOf(filtroTexto.toUpperCase()) > -1
      );
    }

    this.setState({
      filtrosActivos,
      empresasFiltrado,
      filtroTexto
    });

  }

  selectorValue = (text) => {
    sessionStorage.setItem("textFlyer", text);
    history.push(ConfigService.getPathByName("flyerEmpresa")?.url);
    window.location.reload();
  }

  render() {

    var empresasFiltrado = this.state.empresasFiltrado;

    return (

      <div className="content-wrapper">
        <Titulo texto="Convenios" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header" style={{ paddingBottom: 20 }}>
                    <div className="row">
                      <div className="col-md-4">
                        <label className="input-label">Localidades</label>
                        <Select key={this.state.selectedRubro}
                          value={this.state.selectedRubro}
                          onChange={(e) => this.handleChangeFilter({ state: FILTER_STATE.CIUDADES, selectValue: e })}
                          options={this.state.ciudades}
                          placeholder="TODOS"
                          noOptionsMessage={() => 'SIN DATOS'}
                        />
                      </div>
                      <div className="col-md-4">
                        <label className="input-label">Rubros</label>
                        <Select key={this.state.selectedRubro}
                          value={this.state.selectedRubro}
                          onChange={(e) => this.handleChangeFilter({ state: FILTER_STATE.RUBROS, selectValue: e })}
                          options={this.state.rubros}
                          placeholder="TODOS"
                          noOptionsMessage={() => 'SIN DATOS'}
                        />
                      </div>
                      <div className="col-md-4">
                        <label className="input-label">Empresa</label>
                        <input id="inputEntidad"
                          type="text"
                          className="input-box form-control"
                          name="inputEntidad"
                          onChange={(e) => { this.handleChangeFilter({ texto: e.currentTarget.value }) }}
                        />
                      </div>
                    </div>
                  </div>
                  {/* CONTENEDOR DE SERVICIOS - INI*/}
                 
                  </div>
                
                    <div className="col-md-12">
                      <div className="row" >  
                        {empresasFiltrado.length === 0
                          ? <p>Sin Resultados</p>
                          : empresasFiltrado.map(elemento =>
                            /*{console.log("elemento casi card:", elemento)}*/
                            <CardEmpresa
                              key={elemento.idEmpresa}
                              empresa={elemento}
                              pathLogo={null}
                              selectorValue={this.selectorValue}
                            />
                          )}
                      </div>
                    </div>
                  
                    
              </div>
            </div>

          </div>
        </section>
      </div>

    );
  }
}